//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCoreImageUpload from 'vue-core-image-upload'

export default {
  components: {
    'vue-core-image-upload': VueCoreImageUpload,
  },
  data() {
    return {
      func:'',
      src: '',
      iscrop:false,
    }
  },
  methods: {
    imageuploaded(res) {
      if (res.code == 200) {
        this.func(res.data);
        this.src = res.data;
      }
    }
  },
  created:function(){
    this.$eventhub.$on('upimg',(iscrop,func)=>{
      if(iscrop){
        this.iscrop='local'
      }else{
        this.iscrop=false
      }
      this.func=func
      this.$eventhub.$emit('_upimg');
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/upimg.vue